module.exports = __webpack_public_path__ + "static/media/oleg_mild_left.300cd9dc.png";